import React, { Component } from 'react';
import API from '../services/api';
import './Steps.css';
import { Link } from 'react-router-dom';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: this.props.match.params.code,
      password: '',
      message: '',
      errors: {
        password: '',
      },
    }
  }

  componentDidMount() {
    (new API()).post(`/users/reset-password/${this.state.code}`, {})
      .then(response => {
        if(response.error) {
          this.setState({
            errors: {
              password: response.message,
            }
          })
        } else {
          this.setState({
            message: response.message,
          })
        }
      }).catch((error) => {
      this.setState({
        errors: {
          password: error.message
        }
      });
    });
  }

  handleFieldChange(e, name) {

    let newState = this.state;
    newState[name] = e.target.value;
    this.setState(newState);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { password } = this.state;
    if(this.state.password.length > 0) {
      (new API()).post(`/users/reset-password/${this.state.code}`, { password })
        .then(response => {
          if(response.error) {
            this.setState({
              errors: {
                password: response.message,
              }
            })
          } else {
            this.setState({
              message: response.message,
            });
          }
        }).catch((error) => {
            this.setState({
              errors: {
                password: error.message
              }
            });
      });
    }else{
      this.setState({
        errors: {
          password: 'Password must be filled.'
        }
      })
    }
  }

  render() {
    const { errors, message } = this.state;
    return (
      <div className="container">
        <div className="intro">
          <h1>UPPERCLASSDATES</h1>
          <div className="subtitle">
            Reset your password
          </div>
        </div>
        <form className="forgot">
          <div className="Step Step-container active">
            <div className="Step-title">
              Password reset
            </div>
            {message.length === 0 && <div className="Step-intro">
              Enter your new password.
            </div>}
            {message.length > 0 && <div className="Step-intro">
              {message}
            </div>}
            {message.length === 0 && <div className="field-container text open">
              <div className="field-title">Your new password</div>
              <div className="row">
                <div className="col">
                  <input onChange={e => this.handleFieldChange(e, e.target.name)} type="password" name="password" />
                  {errors.password.length > 0 && <span className="error">{errors.password}</span>}
                </div>
              </div>
            </div>}
            {message.length === 0 && <div className="row button-container left space-between">
              <div className="col">
                <button
                  className="btn btn-primary"
                  onClick={(e) => this.handleSubmit(e)}
                >
                  Reset
                </button>
              </div>
            </div>}
          </div>
        </form>
        <div className="texts">
          <div className="row">
            <div className="col center">
              Don't have an account yet? <Link to="/join">Join</Link> now.
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p>
                By continuing you agree to UpperClassDates' <a href="https://upperclassdates.com/privacy-statement/">Privacy Policy</a>.
              </p>
              <p>
                Prostitution and promotion of other commercial activities is prohibited.
              </p>
              <p>
                Are you an escort?, then don't use this website.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default (ResetPassword);


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js